export default {
  namespaced: true,

  state: {
    isShowTerms: false
  },

  mutations: {
    setIsShowTerms(state, value) {
      state.isShowTerms = value
    },
  },

  actions: {
    showTerms({ commit }) {
      commit('setIsShowTerms', true)
    },

    hideTerms({ commit }) {
      commit('setIsShowTerms', false)
    }
  }
}
